/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mitarbeiterinformation1Inputs */



/**

* @param {_Field_Mitarbeiterinformation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_mitarbeiterinformation1 = /** @type {((inputs?: _Field_Mitarbeiterinformation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mitarbeiterinformation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Information für Mitarbeiter")
});
export { _field_mitarbeiterinformation1 as "_field_mitarbeiterInformation" }